import React from 'react';

interface Props {
  children: React.ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * Catches render errors in a subtree so one panel's failure can't blank the
 * whole grid. Useful while backend payload shapes are still in flux.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('Panel render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="panel-center">
          <div className="center-msg">Render error</div>
          <div className="center-sub">{this.state.error.message}</div>
          <button className="retry-btn" type="button" onClick={() => this.setState({ error: null })}>
            ↻ Dismiss
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
